import React from 'react';

export interface AppsGridIconProps {
  size?: number;
  color?: string;
}

/**
 * AppsGridIcon
 *
 * 3×3 grid icon matching Figma right-options.svg.
 * Each cell is a rounded rectangle, arranged in a 3-column grid.
 */
export const AppsGridIcon: React.FC<AppsGridIconProps> = ({
  size = 15,
  color = '#ACACAE',
}) => {
  const cellSize = 3.75;
  const gap = 1.875;
  const radius = 0.5;

  const cells: React.ReactNode[] = [];
  for (let row = 0; row < 3; row++) {
    for (let col = 0; col < 3; col++) {
      cells.push(
        <rect
          key={`${row}-${col}`}
          x={col * (cellSize + gap)}
          y={row * (cellSize + gap)}
          width={cellSize}
          height={cellSize}
          rx={radius}
          fill={color}
        />
      );
    }
  }

  const totalSize = 3 * cellSize + 2 * gap;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${totalSize} ${totalSize}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {cells}
    </svg>
  );
};

export default AppsGridIcon;
